import { Button } from "@progress/kendo-react-buttons";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React from "react";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setSizeDeleteIndex } from "./orderSlice";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";

const SizeDetailArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const SizeDetailDeleteIndex = useAppSelector(
    (state) => state.order.SizeDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const fieldName = fieldArrayRenderProps.name;
  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setSizeDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );
  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps?.onPush({
      value: {
        title: "",
        value: "",
      },
    });
  }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openDialog("sizeDetailDeleteDialog"));
    dispatch(setSizeDeleteIndex(index));
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {/* {fieldArrayRenderProps?.value?.length <= 0 ? pushElementInarray() : null} */}
      {dialogName === "sizeDetailDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Size Detail Data"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(SizeDetailDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 && (
          <GridLayoutItem className="bg-dark text-white fw-600">
            <GridLayout
              style={{
                marginRight: 10,
                padding: 10,
              }}
              gap={{ rows: 0, cols: 10 }}
              cols={[{ width: "47.5%" }, { width: "47.5%" }, { width: "5%" }]}
            >
              <GridLayoutItem>Title</GridLayoutItem>
              <GridLayoutItem>Value</GridLayoutItem>
              <GridLayoutItem>
                <GridLayoutItem
                  style={{
                    position: "sticky",
                    top: 0,
                    right: -25,
                    zIndex: 9,
                    background: "#212529",
                  }}
                ></GridLayoutItem>
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((sizedetails: any, index: number) => (
          <GridLayoutItem key={index}>
            <GridLayout
              style={{ marginRight: 30 }}
              gap={{ rows: 0, cols: 10 }}
              cols={[{ width: "47.5%" }, { width: "47.5%" }, { width: "5%" }]}
            >
              <GridLayoutItem>
                <Field
                  name={`${fieldName}.${index}.title`}
                  // label="Title"
                  wrapperStyle={{ margin: 0 }}
                  placeholder="Title"
                  component={FormTextField}
                  validator={requiredValidator}
                  // astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem>
                <Field
                  name={`${fieldName}.${index}.value`}
                  // label="Value"
                  wrapperStyle={{ margin: 0 }}
                  placeholder="Value"
                  component={FormTextField}
                  validator={requiredValidator}
                />
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  position: "sticky",
                  top: 0,
                  right: 0,
                  zIndex: 9,
                  pointerEvents: "none",
                }}
              >
                <IconButton
                  onClick={() => handleOpenDeleteDialog(index)}
                  // disabled={fieldArrayRenderProps.value.length === 1}
                  themeColor={"error"}
                  size={"small"}
                  fillMode={"solid"}
                  type="button"
                  style={{
                    position: "absolute",
                    height: 28,
                    width: 28,
                    top: 4,
                    right: 0,
                    pointerEvents: "all",
                  }}
                >
                  <MdDelete
                    className="absolute-position"
                    style={{ fontSize: "16px" }}
                  />
                </IconButton>
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        ))}
      <GridLayoutItem style={{ marginTop: 10, textAlign: "left" }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Size Details
        </Button>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default SizeDetailArray;
